import classNames from "classnames";
import BackgroundContext from "contexts/BackgroundContext";
import { AllHTMLAttributes, forwardRef, ReactNode, useContext } from "react";
import Styles from "./Button.module.css";

type NativeButtonProps = AllHTMLAttributes<HTMLButtonElement>;

type ButtonSize = "standard" | "small";
type ButtonVariant = "solid" | "outline";

export type ButtonProps = {
	id?: NativeButtonProps["id"];
	onClick?: NativeButtonProps["onClick"];
	children?: ReactNode;
	tabIndex?: NativeButtonProps["tabIndex"];
	loading?: boolean;
	disabled?: boolean;
	size?: ButtonSize;
	variant?: ButtonVariant;
	inverted?: boolean;
	overlay?: boolean;
	fluid?: boolean;
	className?: string;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
	(
		{
			onClick,
			id,
			children,
			disabled,
			loading,
			size = "standard",
			variant = "solid",
			inverted,
			overlay,
			fluid,
			className,
		},
		ref
	) => {
		const backgroundColor = useContext(BackgroundContext);

		return (
			<button
				ref={ref}
				id={id}
				disabled={loading || disabled}
				className={classNames(
					Styles.resetButton,
					Styles.commonButton,
					{
						[Styles.standardSizeButton]: size === "standard",
						[Styles.smallSizeButton]: size === "small",
						[Styles.solidButton]: variant === "solid",
						[Styles.invertedButton]: inverted || backgroundColor === "dark",
						[Styles.outlineButton]: variant === "outline",
						[Styles.overlayButton]: overlay || backgroundColor === "media",
						[Styles.fluidButton]: fluid,
					},
					className
				)}
				onClick={onClick}
			>
				{children}
			</button>
		);
	}
);

export default Button;
